import { createFileRoute, redirect } from '@tanstack/react-router';
import { TermsScreen } from '@/features/onboarding/TermsScreen';
import { sessionQuery } from '@/lib/session';

export const Route = createFileRoute('/terms')({
  // Mirrors the backend's TosGate (bypass={tos, onboarding, declined}): only
  // the password gate blocks this screen. Anyone with nothing to accept
  // reads the same agreement on the public Terms page instead (/legal, its
  // #terms tab): a visitor who typed or followed /terms, and a signed-in
  // chef who is current on the terms, who used to be bounced to the
  // dashboard with no word. Neither ever sees an inert already-agreed form
  // (legacy app.py:1203-1204).
  beforeLoad: async ({ context }) => {
    const s = await context.queryClient.ensureQueryData(sessionQuery);
    if (!s.authenticated) throw redirect({ to: '/legal', hash: 'terms', replace: true });
    if (s.gates?.password_change_required) throw redirect({ to: '/change-password' });
    if (!s.gates?.tos_required && !s.gates?.account_closed) {
      throw redirect({ to: '/legal', hash: 'terms', replace: true });
    }
  },
  component: TermsScreen,
});
